export const WIRES_MULTIPLE_WORKFLOW_CONTAINER_TAG_NAME = 'wires-multiple-workflow-container';
